import React, { useContext } from 'react';
import { Box, Text, Heading, ButtonPrimary } from '@primer/components'
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';

import { useCategory, CorpusContext } from '../../../hooks/useCorpus'
import { useProduct } from '../../../hooks/useProduct'

import Card from '../../../components/BeforeAfter/CardWithContext'


export default function(props) {
  const { corpus } = useContext(CorpusContext)

  const exampleTest = corpus.UseAssertIsNotNone
  const exampleMistake = corpus.NoMissingComma
  const exampleMistakeDebug = corpus.NoStaticIfCondition
  const exampleUpToDate = corpus.ExplicitFrozenDataclass

  const productDetails = useProduct()

  return (
    <Box className="position-relative pt-md-8 pt-4 pl-4 pr-4">
      <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-0">
        <Heading>More than a linter</Heading>
        <Text className="f3"></Text>
      </Box>

      <Box alignItems="center" className="container-lg clearfix mb-4 mb-md-8">
        <Box className="col-md-12 pb-4">
          <Text className="f3">{productDetails.name} gives clear and actionable advice, which you can commit to your branch directly from your pull request. No more waiting the CI build to finish then reading error logs, tabbing to your text editor, committing the fixes and pushing. Accept the changes right inside your pull request with no context switching.</Text>
        </Box>
        <Card {...exampleUpToDate} hasDelta={true} />
      </Box>

      <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-8">
        <Box className="col-md-5 pb-4 pr-4">
          <Text className="f3 text-bold">Enforce best practice.</Text>
          <Text className="f3"> Skip the docs and stay confident you're following best practice. With {productDetails.name} you stay focused right in your pull request.</Text>
        </Box>
        <Box className="col-md-7 pb-4">
          <Card {...exampleTest} hasDelta={true} />
        </Box>
      </Box>

      <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-8">
        <Box className="col-md-6 pb-4 pr-4">
          <Card {...exampleMistake} hasDelta={true} />
        </Box>
        <Box className="col-md-5 pb-4">
          <Text className="f3 text-bold">Reclaim time.</Text>
          <Text className="f3"> {productDetails.name} works great for quickly detecting mistakes humans might miss, and even links you to the deep archive of best practice articles to upskill devs.</Text>
        </Box>
      </Box>

      <Box alignItems="center" className="container-lg clearfix mb-4 mb-md-8">
        <Box className="col-md-12 pb-4">
          <Text className="f3 text-bold">Prevent bugs.</Text>
          <Text className="f3"> {productDetails.name} knows when code looks fishy and will raise the alarm. With {productDetails.name} you can deploy to prod knowing you've got a code reviewer on your side with the consistency and concentration of a robot.</Text>
        </Box>
        <Card {...exampleMistakeDebug} hasDelta={true} />
      </Box>

    </Box>
  );
}
